import api from './api';

const projetService = {
  // Routes publiques
  getAll: (params = {}) => {
    return api.get('/projets', { params });
  },

  getRecent: () => {
    return api.get('/projets/recent');
  },

  getBySlug: (slug) => {
    return api.get(`/projets/${slug}`);
  },

  // Routes admin
  admin: {
    getAll: (params = {}) => {
      return api.get('/admin/projets', { params });
    },

    getById: (id) => {
      return api.get(`/admin/projets/${id}`);
    },

    create: (data) => {
      return api.post('/admin/projets', data);
    },

    update: (id, data) => {
      // Si c'est un FormData, utiliser POST avec _method=PUT pour Laravel
      if (data instanceof FormData) {
        return api.post(`/admin/projets/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      return api.put(`/admin/projets/${id}`, data);
    },

    delete: (id) => {
      return api.delete(`/admin/projets/${id}`);
    },

    getStatistiques: () => {
      return api.get('/admin/projets/statistiques');
    }
  }
};

export default projetService;

